import createAvailableServiceTypesTranslations from './createAvailableServiceTypesTranslations';

export default function createAvailableServices(data) {
  return {
    id: data.id,
    availableForSubscriptions: data.available_for_subscriptions,
    color: data.color,
    description: data.description,
    icon: data.icon,
    metaTitle: data.meta_title,
    networkId: data.network_id,
    slug: data.slug,
    sorting: data.sorting,
    type: data.type,
    usedAsDefaultForOrderWidget: data.used_as_default_for_order_widget,
    name: data.name,
    translations: createAvailableServiceTypesTranslations(data.translations),
  };
}
